<template>
  <modal
    :title="modalTitle"
    ref="addNewAdditional"
    @save="saveNewAdditional(newAdditional)"
    :disable-save="!inputValueCheck"
  >
    <div class="row">
      <div class="form-group col-md-12">
        <label>Additional Package</label>
        <select
          class="form-control"
          v-model="newAdditional.additionalBillingPackageNumber"
        >
          <option
            v-for="additional in additionalBillingPackages"
            :key="additional.additionalBillingPackageNumber"
            :value="additional.additionalBillingPackageNumber"
          >
            {{ additional.additionalBilling }} - {{ additional.label }} ({{ displayPrice(additional.priceExclVat) }})
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <label>Billing Period</label>
        <v-select
          :options="availableperiods"
          placeholder="Select"
          v-model="newAdditional.billingPeriod"
          :get-option-label="getLabel"
        ></v-select>      
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/GeneralComponents/Modal";
export default {
  components: {
    Modal,
  },
  props: {
    modalTitle: {
      type: String,
      required: true,
    },
    additionalBillingPackages: {
      type: Array,
      required: true,
    },
    availableperiods: {
      type: Array,
      required: true
    }
  },
  emits: ['addAdditionalItem'],
  data() {
    return {
      newAdditional: {
          billingPeriod: 0,
          additionalBillingPackageNumber: 0,
      },
      inputValues: {},
    };
  },
  computed: {
    inputValueCheck() {
      if (this.newAdditional.billingPeriod != 0 && this.newAdditional.additionalBillingPackageNumber != 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    open: function () {
      this.$refs.addNewAdditional.open();
    },
    saveNewAdditional: function () {
      this.$emit("addAdditionalItem", this.newAdditional);
      this.$refs.addNewAdditional.close();
    },
    displayPrice(price) {
      return this.currencyFormat(price);
    },
    getLabel: function(period) {
      return this.prettifyBillingPeriod(period);
    },
  },
};
</script>
